import React from 'react';
import { clientReviews } from '../mock/mock';
import { TrendingUp } from 'lucide-react';

const Testimonials = () => {
  const items = [...clientReviews, ...clientReviews];
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mb-12">
        <div className="text-[#ff8247] text-xs font-bold uppercase tracking-widest mb-3">Ils nous font confiance</div>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
          Rejoignez <span className="gradient-text">12 000+ créateurs</span> qui ont déjà explosé.
        </h2>
      </div>

      <div className="marquee-track flex gap-5 pb-4">
        {items.map((r, i) => (
          <div key={i} className="glass-card rounded-2xl p-5 min-w-[300px] flex items-center gap-4">
            <img src={r.avatar} alt={r.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#ff8247]" />
            <div className="flex-1">
              <div className="text-white font-semibold text-sm">{r.name}</div>
              <div className="text-white/60 text-xs mb-1">{r.text}</div>
              <div className="flex items-center gap-1 text-[#ff8247] font-bold text-sm">
                <TrendingUp className="w-3.5 h-3.5" /> {r.boost}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="marquee-track-reverse flex gap-5 mt-5">
        {items.slice().reverse().map((r, i) => (
          <div key={i} className="glass-card rounded-2xl p-5 min-w-[300px] flex items-center gap-4">
            <img src={r.avatar} alt={r.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#ff2d6f]" />
            <div className="flex-1">
              <div className="text-white font-semibold text-sm">{r.name}</div>
              <div className="text-white/60 text-xs mb-1">{r.text}</div>
              <div className="flex items-center gap-1 text-[#ff8247] font-bold text-sm">
                <TrendingUp className="w-3.5 h-3.5" /> {r.boost}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
